import { USER_PREFERENCE_SETS } from '../../common/utils/constants';

const chartSetV1 = {
  version: '1',
  up: (state) => {
    const { charts, ...rest } = state;

    return {
      ...rest,
      charts: charts.map(({ preferenceId, category, local = false }) => ({
        preferenceId,
        category,
        local,
        query: { actions: ['reboot'] }
      }))
    };
  },
  down: (state) => {
    const { charts, ...rest } = state;

    return {
      ...rest,
      charts: charts.map(({ preferenceId, category, local = false }) => ({
        preferenceId,
        category,
        name: '',
        local
      }))
    };
  }
};

const chartV1 = {
  version: '1',
  up: (state) => {
    const { datasets, scales, ...rest } = state;

    return {
      ...rest,
      datasets: datasets.map(([key, dataset]) => ({ key, ...dataset })),
      scales: scales.map(([key, scale]) => ({ key, ...scale }))
    };
  },
  down: (state) => {
    const { scales, datasets, ...rest } = state;

    return {
      ...rest,
      datasets: datasets.map(({ key, ...restDataset }) => [key, restDataset]),
      scales: scales.map(({ key, ...restScale }) => [key, restScale])
    };
  }
};

const migrationsByCategory = {
  [USER_PREFERENCE_SETS.CHART_SET]: [chartSetV1],
  [USER_PREFERENCE_SETS.CHART]: [chartV1]
};

export function up(preference, to) {
  const migrations = migrationsByCategory[preference.category];

  if (!migrations) {
    return preference;
  }

  const selectedMigrations = select(migrations, preference.state.version, to);

  if (selectedMigrations.length === 0) {
    return preference;
  }

  const state = selectedMigrations.reduce((acc, migration) => migration.up(acc), preference.state);
  state.version = selectedMigrations[selectedMigrations.length - 1].version;

  return { ...preference, state };
}

export function down(preference, to) {
  const migrations = migrationsByCategory[preference.category];

  if (!migrations) {
    return preference;
  }

  const selectedMigrations = select(migrations, to, preference.state.version);

  if (selectedMigrations.length === 0) {
    return preference;
  }

  const state = selectedMigrations.reduceRight((acc, migration) => migration.down(acc), preference.state);
  state.version = migrations[migrations.indexOf(selectedMigrations[0]) - 1]?.version;

  return { ...preference, state };
}

function select(migrations, from, to) {
  const fromIndex = from ? migrations.findIndex((migration) => migration.version === from) : -1;
  const toIndex = to ? migrations.findIndex((migration) => migration.version === to) : migrations.length - 1;

  return migrations.slice(fromIndex + 1, toIndex + 1);
}
